function ArrowUpIconDark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M20 15.4551L12 7.45508L4 15.4551"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowUpIconLight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M20 15.1953L12 7.19531L4 15.1953"
        stroke="#202D38"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function ArrowUpIcon({
  mode = 'dark',
}: {
  mode?: 'light' | 'dark';
}) {
  return <>{mode === 'dark' ? <ArrowUpIconDark /> : <ArrowUpIconLight />}</>;
}
